const Footer = () => {
	return (
		<div className='text-center absolute bottom-0 left-0 w-full p-5 flex justify-center items-center'>
			<p>
				© Copywrite {new Date().getFullYear()},{' '}
				<a
					href='https://feqy.dev'
					className='text-dark hover:text-darkHover font-semibold'
				>
					FEQY.DEV
				</a>{' '}
				| All rights received{' '}
			</p>
		</div>
	);
};

export default Footer;
